import { Flex } from "@acko-tech/building-blocks.ui.common";
import { useOnload } from "@utils/useOnLoad";
import React, { useContext } from "react";
import { Context } from "@components/useContext/context";
import DOMPurify from "isomorphic-dompurify";
import ImageContainer from "@components/imageContainer";
import Hyperlink from "@components/common/hyperlink";
import { Container, Description , Sub } from "./styles";
import { PLAN_IDS } from "@utils/constants";

const NetworkGarage = ({ children, ...props }) => {
  const { planId, desc, nonNetworkGarageDesc, claimDesc, validPlans, sub, styles, src, actions } = props || {};
  const { isDesktop } = useContext(Context);
  const { on_click, on_load } = actions || {};
  useOnload({ on_load });

  if(!validPlans.includes(planId)) return null;

  let description = desc;
  if (PLAN_IDS.NON_NETWORK_GARAGE.includes(planId)) {
    description = nonNetworkGarageDesc;
  } else if (PLAN_IDS.CLAIM_DESC.includes(planId)) {
    description = claimDesc;
  }

  return (
    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
      <Container style={styles}>
        <Flex
          flexDirection="row"
          alignItems="flex-start"
          style={{ gap: "12px" }}
        >
          <ImageContainer imgSrc={src} width={40} height={40} alt="garage-img" />
          <Flex flexDirection="column" style={{ gap: "8px" }}>
            <Description
              isDesktop={isDesktop}
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description)}}
            />
            {sub && (
              <Hyperlink
                clickHandler={() => {
                  if (on_click?.length > 0) {
                    on_click?.forEach((eachFunc: any) => {
                      typeof eachFunc.funCall === "function" &&
                        eachFunc.funCall(eachFunc.args);
                    });
                  }
                }}
                is_visible={true}
                text={sub}
                type="UNDERLINE"
                styles={{
                  display: "inline-block",
                  width: "max-content",
                  color: "#36354C"
                }}
              />
            )}
          </Flex>
        </Flex>
      </Container>
    </Flex>
  );
};

export default NetworkGarage;

